import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import _ from 'lodash'
import {renderTestFields, fourEngines} from '../../constants'
import {formatMinsSecs} from '../common/RenderFields'
import PrintTemplate from 'react-print'

const PrintView = (props) => {

    //console.log('props', props)

    const fields = renderTestFields(props, true, false, false)

    const fields1 = [
        {'field': 'ref', 'title': 'Test reference'},
        {'field': 'startedAt', 'title': 'Test started at'},
        {'field': 'schedulerName', 'title': 'Scheduler name'},
        {'field': 'testerName', 'title': 'Tester name'}
    ]
    //{'field': 'operator', 'title': 'Operator'},
    // {'field': 'aircraft', 'title': 'Aircraft'},

    const fields2 = [
        {'field': 'aircraftRegistration', 'title': 'Aircraft registration'},
        {'field': 'departure', 'title': 'Scheduled departure'},
        {'field': 'status', 'title': 'Test status'},
        {'field': 'heading', 'title': 'Heading'},
        {'field': 'location', 'title': 'Location'},

        {'field': 'antarctic', 'title': 'Antarctic'},
        {'field': 'naturalDisaster', 'title': 'Natural disaster or fault with fleet'},
        {'field': 'approved', 'title': 'Approved'},
        {'field': 'unplanned', 'title': 'Unplanned'},
        {'field': 'runway11InUse', 'title': 'Runway 11 in use'},
        {'field': 'lightMaintenance', 'title': 'Light maintenance'},
        {'field': 'heavyMaintenance', 'title': 'Heavy maintenance'},
        {'field': 'reason', 'title': 'Reason for test'},
        {'field': 'weather', 'title': 'Weather'},
        {'field': 'scheduledDeparture', 'title': 'Scheduled departure'},
        {'field': 'firstEngineOn', 'title': 'First engine on'},
        {'field': 'lastEngineOff', 'title': 'Last engine off'},
        {'field': 'maxSimultaneousHighPower', 'title': 'Max. simultaneous high power engines'},
    ]

    const engines = [];
    const engineNumbers = fourEngines(props.aircraft) ? [1,2,3,4] : [1,2];
    engineNumbers.forEach(i => {
        ['Idle', 'Med', 'High'].forEach(p => {
            engines.push({field: `e${i}${p}`, title: `Engine ${i} ${p.toLowerCase()}`})
        })
    });

    const minutesFields = [
        {'field': 'duration', 'title': 'Duration'},
        ...engines
    ]

    const formatMinutes = (val) => {
        if (0 !== val && !val) {return ''}
        return val < 5 * 60 ? formatMinsSecs(val) : `${Math.round(val / 60)}m`
    }

    return (
        <PrintTemplate>

            <h4>Test summary</h4>

            <Grid fluid>

                <Row className="test-row-print">
                    <Col xs={4}>
                        Maintenance agency
                    </Col>
                    <Col xs={8}>
                        {props.maintenanceAgency}
                    </Col>
                </Row>

                {_.map(fields1, f => <Row key={`print_${f.field}`} className="test-row-print">
                        <Col xs={4}>
                            {f.title}
                        </Col>
                        <Col xs={8}>
                            {fields[f.field]}
                        </Col>
                    </Row>
                )}

                <Row className="test-row-print">
                    <Col xs={4}>
                        Operator
                    </Col>
                    <Col xs={8}>
                        {props.operator === 'Other' ? fields.otherOperator : fields.operator}
                    </Col>
                </Row>

                <Row className="test-row-print">
                    <Col xs={4}>
                        Aircraft
                    </Col>
                    <Col xs={8}>
                        {props.aircraft === 'Other' ? fields.otherAircraft : fields.aircraft}
                    </Col>
                </Row>

                {_.map(fields2, f => <Row key={`print_${f.field}`} className="test-row-print">
                        <Col xs={4}>
                            {f.title}
                        </Col>
                        <Col xs={8}>
                            {fields[f.field]}
                        </Col>
                    </Row>
                )}

                {_.map(minutesFields, f => <Row key={`print_${f.field}`} className="test-row-print">
                        <Col xs={4}>
                            {f.title}
                        </Col>
                        <Col xs={8}>
                            {formatMinutes(props[f.field])}
                        </Col>
                    </Row>
                )}

            </Grid>

        </PrintTemplate>
    );
}

export default PrintView


// WEBPACK FOOTER //
// ./src/components/tests/PrintView.jsx